import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { FormDescription, FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'
import { Input } from '@fortem-monorepo/react-ui'

import { GuidelineFormValues } from '@/pages/funds/ic-guidelines-v2/components/edit-guideline-form/schema'

interface NameFieldProps {}

export const NameField: React.FC<NameFieldProps> = ({}) => {
  const { control, register } = useFormContext<GuidelineFormValues>()

  return (
    <FormField
      name="name"
      control={control}
      render={() => {
        return (
          <FormItem>
            <div className="flex items-center gap-2 overflow-hidden">
              <FormLabel>Name</FormLabel>
              <FormError />
            </div>
            <FormDescription>
              This field will be visible to investors on the report page.
            </FormDescription>
            <Input {...register('name')} />
          </FormItem>
        )
      }}
    />
  )
}
